import { useFormContext } from 'react-hook-form'
import { classNames } from 'utils/classNames'

type Props = {
  label?: string
  name: string
  placeholder?: string
  required?: boolean
  autoComplete?: 'off' | 'on'
  disabled?: boolean
}

export const InputDate = (props: Props) => {
  const {
    label,
    name,
    placeholder,
    required = false,
    autoComplete = 'off',
    disabled = false
  } = props
  const { register } = useFormContext()

  const baseStyle =
    'w-full rounded border border-[#ddd] px-3 py-2 text-sm outline-none'
  const disabledStyle = 'bg-gray-50 text-gray-500'
  return (
    <div className="flex flex-col">
      {label && (
        <label className={'mb-1.5 block text-sm font-medium text-[#555]'}>
          {label}
          {required && <span className={'text-red-500'}>{' *'}</span>}
        </label>
      )}
      <input
        {...register(name)}
        className={classNames([
          baseStyle,
          disabled ? disabledStyle : '',
          'focus:border-b-teal-400'
        ])}
        type={'date'}
        autoComplete={autoComplete}
        placeholder={placeholder}
        disabled={disabled}
      />
    </div>
  )
}
